export const USER_INFO = "USER_INFO";
export const TOKEN = "x-access-token";

function getSessionUser() {
  return getKey(false, USER_INFO).data;
}

function saveUser(info) {
  setKey(true, USER_INFO, info);
  setKey(false, USER_INFO, info);
}

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

function getLocalUser() {
  try {
    const userStr = getKey(true, USER_INFO);
    if (!userStr) return null;
    
    const userData = JSON.parse(userStr);
    return userData || null;
  } catch (error) {
    console.error('获取用户信息失败:', error);
    return null;
  }
}

function saveToken(token) {
  setKey(true, TOKEN, token);
}

function getToken() {
  return getKey(true, TOKEN);
}

function getKey(isLocal, key) {
  try {
    const storage = isLocal ? window.localStorage : window.sessionStorage;
    return storage.getItem(key) || "";
  } catch (error) {
    console.error('获取存储数据失败:', error);
    return "";
  }
}

function setKey(isLocal, key, value) {
  try {
    const storage = isLocal ? window.localStorage : window.sessionStorage;
    storage.setItem(key, value);
  } catch (error) {
    console.error('设置存储数据失败:', error);
  }
}

function rmKey(isLocal, key) {
  try {
    const storage = isLocal ? window.localStorage : window.sessionStorage;
    storage.removeItem(key);
  } catch (error) {
    console.error('删除存储数据失败:', error);
  }
}

function stopPropagation(e) {
  e.stopPropagation();
}

function getLayoutMode() {
  return getKey(true, "LAYOUT_MODE") || "side";
}

function setLayoutMode(mode) {
  setKey(true, "LAYOUT_MODE", mode);
}

// 清除本地数据函数
function clearLocalDatas(keys = []) {
  const allKeys = keys.length === 0 ? [USER_INFO, TOKEN] : keys;
  
  allKeys.forEach(key => {
    rmKey(true, key);   // 清除localStorage
    rmKey(false, key);  // 清除sessionStorage
  });
}

export {
  getSessionUser,
  saveUser,
  sleep,
  getLocalUser,
  saveToken,
  getToken,
  getKey,
  setKey,
  rmKey,
  stopPropagation,
  getLayoutMode,
  setLayoutMode,
  clearLocalDatas,
};
